import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/configuracoes/saldo-caixa')({
  component: lazyRouteComponent(
    () => import('@/features/configuracoes/components/saldo-caixa-tab'),
    'SaldoCaixaTab'
  ),
})
